/**
 * OilCatch BXGY guard
 * Restock Rocket (stoq) enables fetch/XHR hijack and injects Preorder selling_plan
 * on OC-2000. That blocks automatic BXGY (one qty=2 line @ full price).
 * OC-1000 has no selling plan — this strips selling_plan on cart add/change for
 * OC bundle variants so the first drawer paint already shows the discount.
 */
(function () {
  var OC_VARIANT_IDS = {
    '48429098139785': true, // OC-2000
    '45238494331017': true  // OC-1000
  };

  function isOcVariant(id) {
    return OC_VARIANT_IDS[String(id)];
  }

  function cartUrl(url) {
    var s = typeof url === 'string' ? url : (url && url.url) || '';
    return /\/cart\/(add|change)(\.js)?(\?|$)/.test(s);
  }

  function bodyHasOcVariant(obj) {
    if (!obj || typeof obj !== 'object') return false;
    if (isOcVariant(obj.id)) return true;
    if (Array.isArray(obj.items)) {
      for (var i = 0; i < obj.items.length; i++) {
        if (isOcVariant(obj.items[i] && obj.items[i].id)) return true;
      }
    }
    return false;
  }

  function stripObject(obj) {
    if (!obj || typeof obj !== 'object') return obj;
    if (isOcVariant(obj.id) && 'selling_plan' in obj) delete obj.selling_plan;
    if (Array.isArray(obj.items)) {
      obj.items.forEach(function (it) {
        if (it && isOcVariant(it.id) && 'selling_plan' in it) delete it.selling_plan;
      });
    }
    return obj;
  }

  function stripFormData(fd) {
    try {
      var id = fd.get('id') || fd.get('items[0][id]');
      if (isOcVariant(id) || true) {
        // Always drop selling_plan on cart/add; only OC products use RR preorder here
        if (fd.has('selling_plan')) fd.delete('selling_plan');
        // Drop stoq attrs that re-bind the plan
        fd.forEach(function (_v, k) {
          if (k.indexOf('__stoq_data_') !== -1 || k === 'selling_plan') {
            try { fd.delete(k); } catch (e) {}
          }
        });
      }
    } catch (e) {}
    return fd;
  }

  function stripUrlEncoded(str) {
    if (typeof str !== 'string') return str;
    // Only strip when an OC variant id is present
    var hasOc = Object.keys(OC_VARIANT_IDS).some(function (id) {
      return str.indexOf(id) !== -1;
    });
    if (!hasOc) return str;
    return str
      .replace(/(^|&)selling_plan=[^&]*/g, '')
      .replace(/\?&/, '?')
      .replace(/^&/, '')
      .replace(/&&/g, '&');
  }

  function stripInit(input, init) {
    init = init || {};
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    if (!cartUrl(url) && !(input && input.url && cartUrl(input.url))) {
      // Also check Request url
      if (!(typeof Request !== 'undefined' && input instanceof Request && cartUrl(input.url))) {
        return { input: input, init: init };
      }
    }

    var body = init.body;
    // Request with body baked in
    if ((!body || body === undefined) && typeof Request !== 'undefined' && input instanceof Request) {
      // Can't easily rewrite Request body sync without clone; handle via init override below
    }

    if (!body) return { input: input, init: init };

    if (typeof FormData !== 'undefined' && body instanceof FormData) {
      init = Object.assign({}, init, { body: stripFormData(body) });
      return { input: input, init: init };
    }

    if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
      if (isOcVariant(body.get('id'))) body.delete('selling_plan');
      init = Object.assign({}, init, { body: body });
      return { input: input, init: init };
    }

    if (typeof body === 'string') {
      var trimmed = body.trim();
      if (trimmed.charAt(0) === '{') {
        try {
          var obj = JSON.parse(trimmed);
          if (bodyHasOcVariant(obj)) {
            stripObject(obj);
            init = Object.assign({}, init, { body: JSON.stringify(obj) });
          }
        } catch (e) {
          init = Object.assign({}, init, { body: stripUrlEncoded(body) });
        }
      } else {
        init = Object.assign({}, init, { body: stripUrlEncoded(body) });
      }
      return { input: input, init: init };
    }

    return { input: input, init: init };
  }

  function installFetch() {
    if (typeof window.fetch !== 'function') return;
    if (window.fetch.__ocBxgyGuard) return;
    var inner = window.fetch.bind(window);
    function guarded(input, init) {
      try {
        var out = stripInit(input, init);
        input = out.input;
        init = out.init;
      } catch (e) {}
      return inner(input, init);
    }
    guarded.__ocBxgyGuard = true;
    window.fetch = guarded;
  }

  function installXHR() {
    if (typeof XMLHttpRequest === 'undefined') return;
    if (XMLHttpRequest.prototype.__ocBxgyGuard) return;
    var open = XMLHttpRequest.prototype.open;
    var send = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__ocUrl = url;
      return open.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function (body) {
      try {
        if (cartUrl(this.__ocUrl || '') && body) {
          if (typeof FormData !== 'undefined' && body instanceof FormData) {
            body = stripFormData(body);
          } else if (typeof body === 'string') {
            if (body.trim().charAt(0) === '{') {
              try {
                var obj = JSON.parse(body);
                if (bodyHasOcVariant(obj)) body = JSON.stringify(stripObject(obj));
              } catch (e) {
                body = stripUrlEncoded(body);
              }
            } else {
              body = stripUrlEncoded(body);
            }
          }
        }
      } catch (e) {}
      return send.call(this, body);
    };
    XMLHttpRequest.prototype.__ocBxgyGuard = true;
  }

  function install() {
    installFetch();
    installXHR();
  }

  install();
  var n = 0;
  var iv = setInterval(function () {
    install();
    if (++n > 200) clearInterval(iv); // ~10s at 50ms — covers late RR load
  }, 50);
  document.addEventListener('DOMContentLoaded', install);
  window.addEventListener('load', install);
})();
